import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import Button from '@material-ui/core/Button';
import RenderSelectField from "../inputs/renderSelectField";
import MenuItem from '@material-ui/core/MenuItem';
import RenderTextField from "../inputs/renderTextField";

const CriteriaFilterForm =  (props) =>{
  const {filterCriteria, handleSubmit, categories, departments, handleCancel} = props;
  return (
    <form onSubmit={handleSubmit(filterCriteria)}>
      <div className={'form-group'}>
        <Field name="departmentId" label={'Department'} component={RenderSelectField} fullWidth>
          {
            departments.map( department => (
              <MenuItem value={department.id} key={department.id}>{department.name}</MenuItem>
            ))
          }
        </Field>
      </div>
      <div className={'form-group'}>
        <Field name="categoryId" label={'Category'} component={RenderSelectField} fullWidth>
          {
            categories.map(category => (
              <MenuItem value={category.id} key={category.id}>{category.name}</MenuItem>
            ))
          }
        </Field>
      </div>
      <div className={'form-group'}>
        <Field name="weight" label={'Βαρύτητα'} component={RenderSelectField} fullWidth>
          <MenuItem value={'new'} >{'Νέα'}</MenuItem>
          <MenuItem value={'newComing'} >{'Υφιστάμενη'}</MenuItem>
          <MenuItem value={'old'} >{'Εξάμηνη'}</MenuItem>
        </Field>
      </div>
      <div className={'form-group'}>
        <Field name="name" label={'Name'} component={RenderTextField} type="text" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field name="code" label={'Code'} component={RenderTextField} type="text" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Button type={'submit'} variant="contained" color="primary" className={'mr-3'}>
          {'Filter'}
        </Button>
        <Button onClick={handleCancel} variant="contained" color="secondary">
          {'Cancel'}
        </Button>
      </div>
    </form>
  )

};

export default reduxForm({
  enableReinitialize: true,
  form: 'criteriaFilterForm',
})(CriteriaFilterForm);



// WEBPACK FOOTER //
// ./src/components/criteria/criteriaFilterForm.js